import { PlaceholderPlugin } from "@platejs/media/react";
import FontAwesome from "../../../utilities/FontAwesome";
import styles from "../../styles/SlateEditor.module.scss";
import { useEditorRef } from "platejs/react";
import classNames from "classnames";

export function ImageUploadButton() {
  const editor = useEditorRef();

  return (
    <div
      className={classNames(
        styles.button,
        styles.buttonWithTooltip,
        styles.imageUploadButton,
      )}
      data-content={"Upload Image"}
    >
      <input
        type="file"
        accept={"image/*"}
        onChange={(e) => {
          const files = e.target.files;
          if (files && files.length > 0) {
            editor.getTransforms(PlaceholderPlugin).insert.media(files);
          }
        }}
        id={"slate-image-input"}
        name={"slate-image-input"}
      />
      <label htmlFor={"slate-image-input"}>
        <FontAwesome fixedWidth prefix={"far"} name={"fa-image"} />
      </label>
    </div>
  );
}
